import { DriversLicense, SectionMessage } from "@certn/cascadia-react";
import { ControlProps } from "@jsonforms/core";
import { withJsonFormsControlProps } from "@jsonforms/react";
import { Trans } from "react-i18next";

export function DriversLicensePreviewControl(schema: ControlProps) {
  if (schema.data?.issuing_country === "NOT_LISTED") {
    return (
      <SectionMessage
        icon="info"
        sectionTitle="Digital motor vehicle records unavailable"
      >
        <Trans>
          Digital motor vehicle records are currently unavailable in this
          location. Your prospective employer may ask you to submit physical
          paperwork instead. Please proceed to the next step.
        </Trans>
      </SectionMessage>
    );
  }

  if (!schema.data?.issuing_country || !schema.data?.issuing_region) {
    return null;
  }

  return (
    <DriversLicense
      country={schema.data.issuing_country}
      region={schema.data.issuing_region}
      title={schema.label}
    />
  );
}

export const DriversLicensePreviewRenderer = withJsonFormsControlProps(
  DriversLicensePreviewControl
);
